
export type GetSessionStatus200 = {
  /** 세션 인증 상태 */
  authenticated?: boolean;
  /** 세션 생성 시간 (밀리초) */
  creationTime?: number;
  /** HTTP 세션 존재 여부 */
  hasSession?: boolean;
  /** 새로 생성된 세션 여부 */
  isNew?: boolean;
  /** JWT 토큰 인증 상태 */
  jwtAuthenticated?: boolean;
  /** JWT 토큰의 사용자 ID */
  jwtUserId?: string;
  /** 마지막 접근 시간 (밀리초) */
  lastAccessedTime?: number;
  /** 세션 최대 유지 시간 (초) */
  maxInactiveInterval?: number;
  /** 세션 ID (세션이 있는 경우) */
  sessionId?: string;
  /** 세션에 저장된 사용자 이메일 */
  userEmail?: string;
  /** 세션에 저장된 사용자 ID */
  userId?: string;
};
